import styled from 'styled-components';

export const QuestionContainer = styled.div`
  text-align: center;

  h3 {
    text-align: center;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    margin: 3em 0 0;
  }
`;

export const BackButtonContent = styled.div`
  @media ${({ theme }) => theme.queries.minDesktop} {
    width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 12px;
    position: relative;

    > h1:nth-child(2),
    > h2:nth-child(2),
    > span:nth-child(2) {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
    }

    > button:first-child {
      position: relative;
      z-index: 1;
    }

    > button:nth-child(3),
    > div:nth-child(3) {
      position: relative;
      z-index: 1;
      margin-left: auto;
    }
  }
`;

export const HeaderPlaceholder = styled.span`
  @media ${({ theme }) => theme.queries.minDesktop} {
    visibility: hidden;
    pointer-events: none;
  }
`;

export const QuizResultContainer = styled.div`
  @media ${({ theme }) => theme.queries.minDesktop} {
    margin: 3em 0;
  }
`;

export const AppointmentTypeCards = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  flex-direction: column;

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;
  }
`;
